<template>
    <a-modal
            :visible="showForgotPasswordModal"
            @cancel="_changeForgotPasswordModal(false)"
            :footer="null"
            width="380px"
            :bodyStyle="bodyStyle"
    >
        <div>
            <div slot="title" style="text-align: center">忘记密码</div>
            <div>
                <p>
                    <a-input placeholder="请输入账号" style="margin: 10px 0"
                                      v-model="newUserInfo.loginName" />
                    <a-input-password placeholder="请输入新密码" style="margin: 10px 0"
                                      v-model="newUserInfo.newPassword" />
                    <a-input-password placeholder="请再次输入新密码" style="margin: 10px 0"
                                      v-model="newUserInfo.checkNewPassword"/>
                    <a-input placeholder="请输入手机号" style="margin: 10px 0"
                             v-model="newUserInfo.mobile" />
                    <a-input placeholder="请输入验证码" style="margin: 10px 20px 0 0  ;width: 50%"
                             v-model="newUserInfo.code" />
                    <a-button type="primary" @click="sendCode" :disabled=show>{{countText}}</a-button>
                </p>
<!--                <button @click="submit">确定</button>-->
                <a-button type="primary" :loading="loading" @click="submit" style="margin-top: 20px">确定更改密码</a-button>

                <div style="margin-top: 14px">
                    <a class="login-form-forgot" @click="_changeLoginModal(true)" href="#">
                        去登录
                    </a>
                    <a class="register" @click="_changeRegisterModal(true)">立即注册!</a></div>
            </div>
        </div>
    </a-modal>
</template>

<script>
    import common from "../../mixin/common";
    import {createNamespacedHelpers} from "vuex";
    import {forgetPassword, forgetPasswordSendCode} from "@api/personal-api"
    import { showWaringMsg, showSuccessMsg} from "@utils/msg";
    const {mapState} = createNamespacedHelpers('login');
    export default {
        name: "ForgotPassword",
        mixins: [common],
        computed: {
            ...mapState(['showForgotPasswordModal'])
        },
        data() {
            return {
                bodyStyle: {
                    padding: '20px 36px 24px'
                },
                //    用户信息
                newUserInfo: {
                    mobile: "",
                    code: "",
                    loginName: "",
                    newPassword: "",
                    checkNewPassword: "",
                },

                //    验证码倒计时
                show: false,
                count: 0,
                countText: "获取验证码",
                timer: null,

                //    点击加载中
                loading: false,
            }
        },
        methods:{
            //更改密码
            submit(){
                this.loading = true
                // var reg2 = /^\S{6,20}$/;
                //不许有中文
                let pattern = /^[^\u4e00-\u9fa5]{0,}$/
                if (this.newUserInfo.loginName == "" || this.newUserInfo.newPassword == "" || this.newUserInfo.mobile == "" || this.newUserInfo.code == "") {
                    showWaringMsg('各项不能为空！');
                    this.loading = false
                }
                // else if(
                //      !reg2.test(this.newUserInfo.loginName)||  !reg2.test(this.newUserInfo.newPassword) ){
                //     showWaringMsg('请正确输入4-20位的用户名和密码，禁止使用汉字和空格!');
                //     this.loading = false
                // }
                else if (!pattern.test(this.newUserInfo.loginName) || !pattern.test(this.newUserInfo.password)) {
                    showWaringMsg('请正确输入用户名和密码，禁止使用汉字和空格!');
                    this.loading = false
                } else if (this.newUserInfo.checkNewPassword != this.newUserInfo.newPassword) {
                    showWaringMsg('两次密码不一致，请重新输入!');
                    this.loading = false
                } else {
                    // 提交一下
                    forgetPassword(this.newUserInfo.loginName, this.newUserInfo.newPassword, this.newUserInfo.mobile, this.newUserInfo.code).then((res) => {
                        if (res.code === 0) {
                            showSuccessMsg(res.msg)
                            // 跳转到登陆
                            this._changeForgotPasswordModal(false);
                            this._changeLoginModal(true);
                            this.loading = false
                        } else if (res.code === 500) {

                            this.loading = false
                        } else {
                            this.loading = false
                        }

                    })
                }
            },

            //获取验证码
            sendCode() {
                this.show = true;
                let phoneChecking = /^1[3456789]\d{9}$/
                if (!phoneChecking.test(this.newUserInfo.mobile)) {
                    showWaringMsg('手机号格式不正确，请重新输入！');
                    this.show = false;
                    return false;
                } else if (this.newUserInfo.loginName == "") {
                    showWaringMsg('请填写账号！');
                    this.show = false;
                    return false;
                } else {
                    forgetPasswordSendCode(this.newUserInfo.loginName, this.newUserInfo.mobile).then((res) => {
                        if (res.code == 0) {
                            showSuccessMsg('发送成功，注意查收并正确填写验证码');
                            //    60秒倒计时
                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.count = TIME_COUNT;
                                // this.show = false;
                                this.timer = setInterval(() => {
                                    if (this.count > 0 && this.count <= TIME_COUNT) {
                                        this.show = true;
                                        this.count--;
                                        this.countText = this.count + "s后重试"
                                    } else {
                                        this.show = false;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                        this.countText = "获取验证码"
                                    }
                                }, 1000)
                            }
                        } else if (res.code == 500) {
                            this.show = false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.countText = "获取验证码"
                        } else {
                            this.show = false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.countText = "获取验证码"
                        }


                    })
                }
            },

        }
    }
</script>

<style scoped lang="less">
    .login-form-forgot {
        float: right;
        color: #999999;
    }

    .register {
        color: #999999;
    }

    .register:hover {
        color: #00CF8C;
    }

    .login-form-forgot:hover {
        color: #00CF8C;
    }
</style>
